import { Box, Typography, Grid, Link } from '@mui/material';
import {
  businessDetailsSectionContainerSx,
  businessDetailsSectionTitleSx,
  businessDetailsLinkTextSx,
  businessDetailsLinkSx
} from '../../styles/createCampaign';
import { Input } from 'src/components/UI/Input';
import { Controller, useFormContext } from 'react-hook-form';
import { ConfirmAndPayFormData } from './index';

export const BusinessLocationInfo = () => {
  const {
    control,
    formState: { errors },
    watch
  } = useFormContext<ConfirmAndPayFormData>();

  // Watch country to determine if state/County/Region is required
  const country = watch('businessLocationInfo.country');
  // Countries where state/County/Region is required
  const requiredCountries = ['USA', 'GBR', 'CAN', 'AUS'];
  const isStateCountyRegionRequired = country
    ? requiredCountries.includes(country)
    : false;

  return (
    <Box sx={businessDetailsSectionContainerSx}>
      <Typography sx={businessDetailsSectionTitleSx}>
        Business Location Info
      </Typography>

      <Grid container spacing={{ xs: 1.5, sm: 2 }}>
        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationInfo.name"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Business name"
                required
                disabled
                fullWidth
                placeholder="Enter business name"
                error={!!errors.businessLocationInfo?.name}
                helperText={errors.businessLocationInfo?.name?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationInfo.country"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Country"
                required
                fullWidth
                placeholder="Enter country"
                error={!!errors.businessLocationInfo?.country}
                helperText={errors.businessLocationInfo?.country?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationInfo.firstLine"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="First Line"
                required
                fullWidth
                placeholder="Enter first line of address"
                error={!!errors.businessLocationInfo?.firstLine}
                helperText={errors.businessLocationInfo?.firstLine?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationInfo.secondLine"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Second Line"
                fullWidth
                placeholder="Enter Address"
                error={!!errors.businessLocationInfo?.secondLine}
                helperText={errors.businessLocationInfo?.secondLine?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationInfo.townCity"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Town/City"
                fullWidth
                placeholder="Enter town or city"
                error={!!errors.businessLocationInfo?.townCity}
                helperText={errors.businessLocationInfo?.townCity?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationInfo.stateCountyRegion"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="State/County/Region"
                fullWidth
                placeholder="Enter state, county or region"
                error={!!errors.businessLocationInfo?.stateCountyRegion}
                helperText={errors.businessLocationInfo?.stateCountyRegion?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationInfo.postcode"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Postcode"
                fullWidth
                placeholder="Enter postcode"
                error={!!errors.businessLocationInfo?.postcode}
                helperText={errors.businessLocationInfo?.postcode?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="businessLocationInfo.businessPhoneNumber"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Business Phone Number"
                required
                fullWidth
                placeholder="Enter phone number"
                error={!!errors.businessLocationInfo?.businessPhoneNumber}
                helperText={errors.businessLocationInfo?.businessPhoneNumber?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            name="businessLocationInfo.businessWebsiteUrl"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="Business website URL"
                required
                fullWidth
                placeholder="Enter website URL"
                error={!!errors.businessLocationInfo?.businessWebsiteUrl}
                helperText={errors.businessLocationInfo?.businessWebsiteUrl?.message}
              />
            )}
          />
        </Grid>
      </Grid>

      <Typography sx={businessDetailsLinkTextSx}>
        Incorrect business details?{' '}
        <Link href="#" sx={businessDetailsLinkSx}>
          Update in Business Profile
        </Link>
        ,{' '}
        <Link href="#" sx={businessDetailsLinkSx}>
          Google Listing Manager
        </Link>
      </Typography>
    </Box>
  );
};

